import Axios from 'axios';

import { REQUEST } from '@/constants/api';
import { VITE_KEY_PLACE_AUTOCOMPLETE } from '@/constants/configs';

import { Tenant } from '@/types/common';
import { GooglePlaceApiResponse, Territory } from '@/types/places';

import { getCookie } from '@/utils/browser';
import { parseAddressComponents } from '@/utils/places';

import { axios } from './axios';

export const getTerritories = async () => {
  const result = await axios.get<Territory[]>(REQUEST.TERRITORIES);

  const territories = result.data as Territory[];

  const testBeta = getCookie('test-beta');

  if (
    testBeta &&
    testBeta === '1' &&
    !territories.some(item => item.tenant === Tenant.SintMaarten)
  ) {
    return [
      ...territories,
      {
        id: '70fd6060-a40d-41c2-a303-cc543fdece9c',
        country: 'Sint Maarten',
        countryCode: 'SXM',
        tenant: 'sxm',
        branches: [
          {
            id: '6ab9165b-270a-42c6-b399-9550e5cefe14',
            branchName: 'Simpson Bay',
            branchNo: '702',
          },
          {
            id: '0d41e73f-efea-4623-a834-ef279e809794',
            branchName: 'Philipsburg',
            branchNo: '701',
          },
        ],
      } as Territory,
    ];
  }

  return result.data as Territory[];
};

export const getPlaceDetails = async (placeId: string) => {
  try {
    const result = await Axios.get<GooglePlaceApiResponse>(
      REQUEST.VENDOR.PLACES.DETAILS(placeId),
      {
        params: {
          fields: 'id,displayName,name,addressComponents,formattedAddress',
          languageCode: 'en',
          key: VITE_KEY_PLACE_AUTOCOMPLETE,
        },
      },
    );

    return parseAddressComponents(result.data);
  } catch {
    return null;
  }
};
